module.exports = __webpack_public_path__ + "img/Responsability-HSSE-Security.537c148f.jpg";